<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style  lang="scss">
  .map-round-table-wrapper ul {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.map-round-table-wrapper ul li {
  width: 23.96%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 43px;
  padding: 10px;
  border: 1px solid #4c8af6;
  margin: 5px;
  border-radius: 5px;
}
.map-round-table-wrapper {
  overflow-y: auto;
}
</style>

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full md:mt-2 name-evnt">
        <label class="type-evnt-lbl">Event Name</label>
        <vs-input
          class="w-full"
          v-validate="'required'"
          name="Event Full Name"
          v-model="EventData.EventFullName"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Event Full Name')"
          >{{ errors.first("Event Full Name") }}</span
        >
      </div>
      <div class="vx-col sm:w-6/12 w-full mt-2">
        <label class="type-evnt-lbl">Time Zone</label>
        <vs-select
            v-model="EventData.TimeZone"
            class="w-full select-large"
            :options="tzStrings"
          >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.label"
            v-for="(item, index) in tzStrings"
            class="w-full"
          />
        </vs-select>
      </div>
      <div class="vx-col sm:w-1/2 w-full evnt-date mt-2">
        <label class="type-evnt-lbl">Event Start Date</label>
          <flat-pickr
            :config="configdateTimePickerStart"
            class="time-pkr"
            placeholder="Start Date"
            v-validate="'required'"
            name="Event Start Date"
            v-model="EventData.EventStartDate"
          ></flat-pickr>
          <span
            class="text-danger text-sm"
            v-show="errors.has('Event Start Date')"
            >{{ errors.first("Event Start Date") }}</span
          >
      </div>
      <div class="vx-col sm:w-1/2 w-full evnt-date mt-2">
          <label class="type-evnt-lbl">Event End Date</label>
            <flat-pickr
              :config="configdateTimePickerEnd"
              class="time-pkr"
              placeholder="End Date"
              v-validate="'required'"
              name="Event End Date"
              v-model="EventData.EventEndDate"
            ></flat-pickr>
            <span
              class="text-danger text-sm"
              v-show="errors.has('Event End Date')"
              >{{ errors.first("Event End Date") }}</span
            >
      </div>
      <div class="vx-col sm:w-1/1 w-full evnt-date mt-5">
        <label class="type-evnt-lbl">Select what you want to copy to the new event</label>
        <div class="map-round-table-wrapper mt-3">
          <ul class="centerx">
            <li v-for="modul in allModules">
              <vs-checkbox v-model="SelectedModules" :vs-value="modul">{{modul}}</vs-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 text-right">
            <vs-button color="primary" type="border" class="mt-2 mr-3" @click="closePopup">Close</vs-button>
            <vs-button
              class="ml-auto mt-2"
              @click="before_save"
              :disabled="!validateForm"
            >Save</vs-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import moment from "moment-timezone";
import ls from "@/common/localStorage";

let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
var vm
export default {
  components: {
    Datepicker,
    flatPickr,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      EventData: this.data,
      tzStrings: [
        {
          label: "(GMT-12:00) International Date Line West",
          value: "Etc/GMT+12",
        },
        { label: "(GMT-11:00) Midway Island, Samoa", value: "Pacific/Midway" },
        { label: "(GMT-10:00) Hawaii", value: "Pacific/Honolulu" },
        { label: "(GMT-09:00) Alaska", value: "US/Alaska" },
        {
          label: "(GMT-08:00) Pacific Time (US & Canada)",
          value: "America/Los_Angeles",
        },
        {
          label: "(GMT-08:00) Tijuana, Baja California",
          value: "America/Tijuana",
        },
        { label: "(GMT-07:00) Arizona", value: "US/Arizona" },
        {
          label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
          value: "America/Chihuahua",
        },
        {
          label: "(GMT-07:00) Mountain Time (US & Canada)",
          value: "US/Mountain",
        },
        { label: "(GMT-06:00) Central America", value: "America/Managua" },
        {
          label: "(GMT-06:00) Central Time (US & Canada)",
          value: "US/Central",
        },
        {
          label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
          value: "America/Mexico_City",
        },
        { label: "(GMT-06:00) Saskatchewan", value: "Canada/Saskatchewan" },
        {
          label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
          value: "America/Bogota",
        },
        {
          label: "(GMT-05:00) Eastern Time (US & Canada)",
          value: "US/Eastern",
        },
        { label: "(GMT-05:00) Indiana (East)", value: "US/East-Indiana" },
        {
          label: "(GMT-04:00) Atlantic Time (Canada)",
          value: "Canada/Atlantic",
        },
        { label: "(GMT-04:00) Caracas, La Paz", value: "America/Caracas" },
        { label: "(GMT-04:00) Manaus", value: "America/Manaus" },
        { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
        { label: "(GMT-03:30) Newfoundland", value: "Canada/Newfoundland" },
        { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
        {
          label: "(GMT-03:00) Buenos Aires, Georgetown",
          value: "America/Argentina/Buenos_Aires",
        },
        { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
        { label: "(GMT-03:00) Montevideo", value: "America/Montevideo" },
        { label: "(GMT-02:00) Mid-Atlantic", value: "America/Noronha" },
        { label: "(GMT-01:00) Cape Verde Is.", value: "Atlantic/Cape_Verde" },
        { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
        {
          label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
          value: "Africa/Casablanca",
        },
        {
          label: "(GMT+00:00) Coordinated Universal Time",
          value: "UTC",
        },
        {
          label:
            "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
          value: "Etc/Greenwich",
        },
        {
          label: "(GMT+00:00) Western Europe Time, London, Lisbon, Casablanca",
          value: "Europe/London",
        },
        {
          label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
          value: "Europe/Amsterdam",
        },
        {
          label:
            "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
          value: "Europe/Belgrade",
        },
        {
          label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
          value: "Europe/Brussels",
        },
        {
          label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
          value: "Europe/Sarajevo",
        },
        { label: "(GMT+01:00) West Central Africa", value: "Africa/Lagos" },
        { label: "(GMT+02:00) Amman", value: "Asia/Amman" },
        {
          label: "(GMT+02:00) Athens, Bucharest, Istanbul",
          value: "Europe/Athens",
        },
        { label: "(GMT+02:00) Beirut", value: "Asia/Beirut" },
        { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
        { label: "(GMT+02:00) Harare, Pretoria", value: "Africa/Harare" },
        {
          label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
          value: "Europe/Helsinki",
        },
        { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
        { label: "(GMT+02:00) Minsk", value: "Europe/Minsk" },
        { label: "(GMT+02:00) Windhoek", value: "Africa/Windhoek" },
        { label: "(GMT+03:00) Kuwait, Riyadh, Baghdad", value: "Asia/Kuwait" },
        { label: "(GMT+03:00) Baghdad", value: "Asia/Baghdad" },
        {
          label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
          value: "Europe/Moscow",
        },
        { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
        { label: "(GMT+03:00) Tbilisi", value: "Asia/Tbilisi" },
        { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
        { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
        { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
        { label: "(GMT+04:00) Yerevan", value: "Asia/Yerevan" },
        { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
        { label: "(GMT+05:00) Yekaterinburg", value: "Asia/Yekaterinburg" },
        {
          label: "(GMT+05:00) Islamabad, Karachi, Tashkent",
          value: "Asia/Karachi",
        },
        {
          label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
          value: "Asia/Calcutta",
        },
        { label: "(GMT+05:45) Kathmandu", value: "Asia/Katmandu" },
        { label: "(GMT+06:00) Almaty, Novosibirsk", value: "Asia/Almaty" },
        { label: "(GMT+06:00) Astana, Dhaka", value: "Asia/Dhaka" },
        { label: "(GMT+06:30) Yangon (Rangoon)", value: "Asia/Rangoon" },
        { label: "(GMT+07:00) Bangkok, Hanoi, Jakarta", value: "Asia/Bangkok" },
        { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
        {
          label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
          value: "Asia/Hong_Kong",
        },
        { label: "(GMT+08:00) Kuala Lumpur", value: "Asia/Kuala_Lumpur" },
        { label: "(GMT+08:00) Singapore", value: "Asia/Singapore" },
        { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "Asia/Irkutsk" },
        { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
        { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
        { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
        { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
        { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
        { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
        { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
        { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
        {
          label: "(GMT+10:00) Canberra, Melbourne, Sydney",
          value: "Australia/Canberra",
        },
        { label: "(GMT+10:00) Hobart", value: "Australia/Hobart" },
        { label: "(GMT+10:00) Guam, Port Moresby", value: "Pacific/Guam" },
        { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
        {
          label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
          value: "Asia/Magadan",
        },
        {
          label: "(GMT+12:00) Auckland, Wellington",
          value: "Pacific/Auckland",
        },
        {
          label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
          value: "Pacific/Fiji",
        },
        { label: "(GMT+13:00) Nuku'alofa", value: "Pacific/Tongatapu" },
      ],
      configdateTimePickerStart: {
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerEnd: {
        minDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      allModules: ['Analytics', 'AttendeeList', 'EventInfo', 'ExhibitorList',
        'Features', 'LocationList', 'MeetingList', 'Menu', 'PhotoWall', 'RoundTableList',
        'RoundTableTopicList', 'SessionList', 'Settings', 'SpeakerList', 'SponsorList', 'TrackList', 'mailtpl'
      ],
      SelectedModules: []
    };
  },
  watch: {
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    GetTimeByZone: function (strDateTime, timeZone) {
      debugger;
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    closePopup(){
      this.$emit("closePopup");
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    save_changes(){
      if (!this.validateForm) return;
      this.EventData.StartDate = this.GetTimeByZone(
        this.EventData.EventStartDate,
        this.EventData.TimeZone
      );
      this.EventData.EndDate = this.GetTimeByZone(
        this.EventData.EventEndDate,
        this.EventData.TimeZone
      );
      //this.EventData.StartDate = new Date(this.EventData.EventStartDate)
      //this.EventData.EndDate = new Date(this.EventData.EventEndDate)
      console.log(this.EventData.EndDate)
      console.log(new Date(this.EventData.EndDate))
      this.$vs.loading();
      this.$store.dispatch("eventManagement/cloneEvent", { data: this.EventData, SelectedModules: this.SelectedModules })
          .then((res) => {            
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Event",
                text: "Event created successfully.",
              });
              this.closePopup()
              location.href = '/event/list';
            }
            else{
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Event",
                text: "Event not created!",
              });
            }
          })
    }
  },
  mounted(){
  },
  created(){
   vm = this
  }
};
</script>